import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import BooleanField from 'components/show/BooleanField';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import Section from 'components/ui/general/Section';
import TextField from 'components/show/TextField';
import Title from 'components/ui/general/Title';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ImageIcon } from 'assets/materialIcons/materialIcons';
import DeleteButton from 'components/button/DeleteButton';
import { deleteMembershipSchedule } from 'store/actions/membership-schedules/deleteMembershipSchedules';
import MembershipScheduleField from 'components/show/MembershipScheduleField';

const MembershipShow = (props) => {
    const {
        id,
        history,
        record,
        resource,
        translate,
    } = props;

    const breadcrumbs = [
        {
            label: translate('menu.sidebar.membership_schedules'),
            link: '/membership-schedules',
        },
        {
            label: record.name,
        },
    ];

    const onDeleteMembershipSchedule = () => {
        return deleteMembershipSchedule({
            id,
            onSuccess: () => {
                return history.push('/membership-schedules');
            },
        });
    };

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ record.name }/>

                <Actions>
                    <EditButton
                        icon={ <ImageIcon color={ theme.palette.doveGray } /> }
                        url={ `/${ resource }/${ id }` }
                    />

                    <DeleteButton action={ onDeleteMembershipSchedule } record={ record } />
                </Actions>
            </Header>

            <Section>
                <Column title={ translate('resources.discounts.forms.general') }>
                    <InnerColumn>

                        <TextField
                            label={ translate('filters.components.name.label') }
                            value={ record.name }
                        />

                        <BooleanField
                            label={ translate('resources.products.fields.is_visible') }
                            value={ record.is_visible || false }
                        />

                    </InnerColumn>
                </Column>
            </Section>
            <Section>
                <Column>
                    <InnerColumn>
                        <MembershipScheduleField schedule={ record } />
                    </InnerColumn>
                </Column>
            </Section>
        </div>
    );
};

MembershipShow.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }),
    id: PropTypes.number,
    record: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(MembershipShow);



// WEBPACK FOOTER //
// ./src/pages/membership-schedules/show/MembershipScheduleShow.js